import {useCallback, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {RootState} from "../store";
import {DataTableRequest} from "../types/Requests/API/DataTableRequest";
import {setDataTableRequest} from "../reducers/dataTableSearch";

const usePersistedDataTableRequest = <T extends DataTableRequest>(defaultRequest: T) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const storedRequest = useSelector((state: RootState) => state.dataTableSearch[location.pathname]) as T | undefined;

    const request = useMemo<T>(() => storedRequest ?? defaultRequest, [storedRequest, defaultRequest]);

    const updateRequest = useCallback((nextRequest: T) => {
        dispatch(setDataTableRequest({path: location.pathname, request: nextRequest}));
    }, [dispatch, location.pathname]);

    return [request, updateRequest] as const;
}

export default usePersistedDataTableRequest;
